<script setup lang="ts">
import type { EditorialStripAnchorsProps } from './EditorialStripAnchors.props'
import type { EditorialStripAnchorsItemProps } from './EditorialStripAnchorsItem.props'

const props = defineProps<EditorialStripAnchorsProps>()

const { isAnyDialogOpen } = useDialog()

const isAnimating = ref(true)

const startPauseAnimation = (action: string = '') => {
  if (action === 'leave' && isAnyDialogOpen.value) return
  isAnimating.value = !isAnimating.value
}

watch(isAnyDialogOpen, () => (isAnimating.value = !isAnyDialogOpen.value))

const displayedItemsForLocale = computed(() => {
  return props.contentStrip.filter(stripItem => {
    return stripItem.showInCountry || stripItem.showInAllCountries
  })
})

const { dispatchViewPromotionEvent, dispatchSelectPromotionEvent } =
  useGAPromotionEvents()

const stripAnchorsList = ref(
  displayedItemsForLocale.value
    ? displayedItemsForLocale.value.map(message =>
        message.link.label ? message.link.label : null
      )
    : []
)

onMounted(() => {
  if (stripAnchorsList.value.length > 0) {
    dispatchViewPromotionEvent(stripAnchorsList?.value[0] ?? '', [], true)
  }
})

const handleClick = (item: EditorialStripAnchorsItemProps) => {
  dispatchSelectPromotionEvent(
    'carousel_slider',
    item.link?.target ?? '',
    item.link.label ?? ''
  )
}
</script>
<template>
  <div
    class="border-y-neutral-gray lg:py-4xl px-md py-xxl overflow-hidden border-y"
    :class="[
      bgColorStrip ? `bg-neutral-${bgColorStrip}` : 'bg-background-secondary',
    ]"
    @mouseenter="startPauseAnimation()"
    @mouseleave="startPauseAnimation('leave')"
  >
    <div class="-mx-3 flex flex-nowrap lg:-mx-6">
      <ul
        v-for="i in 2"
        :key="i"
        class="infinite-scroll gap-xxl px-md flex lg:min-w-full lg:justify-between"
        :style="[
          {
            'animation-play-state': `${isAnimating ? 'running' : 'paused'}`,
          },
        ]"
      >
        <li
          v-for="(stripItem, index) in displayedItemsForLocale"
          :key="`strip-item-${index}`"
          :style="{ '--total-items': displayedItemsForLocale.length }"
          class="dinamic-content-width"
        >
          <EditorialStripAnchorsItem
            v-bind="stripItem"
            :text-color="textColor"
            :type="type"
            @emit-item="handleClick(stripItem)"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped lang="scss">
.infinite-scroll {
  @apply transform-gpu;
  animation: scroll-animation 60s linear infinite;
  will-change: transform;
}

@keyframes scroll-animation {
  0% {
    transform: translate(0);
  }
  100% {
    transform: translate(-100%);
  }
}

.dinamic-content-width {
  @screen lg {
    width: calc(100% / var(--total-items));
  }
}
</style>
